<template>
  <div class="page" v-wechat-title="$route.meta.title='城市选择'">

    <form class="search-box border-box" v-on:submit.prevent="search">
      <img class="icon-search" src="../../assets/icon_search.png" @click='search' />
      <input type="text" placeholder="搜索城市" class="search-input" value="" v-model='inputValue' />
    </form>

    <template v-if="!sregion">
      <p class="icon-address-box">当前位置</p>
      <div class="location" @click="citySelected(cityInfo.city,cityInfo.citycode)">
        <span class="fl">{{cityInfo.city}}</span>
        <span class="fr" @click.stop="getMyLocation"><img src="../../assets/icon_location.png"/>重新定位</span>
      </div>
    </template>

    <p class="city-item-A-Z hot-city-title border-box">热门城市</p>
    <div class="hot-city-box border-box">
      <div class="img hot-city-con" v-for="(item,index) in hotCitys" @click="citySelected(item.city,item.code)">
        <img class="hot-city-img" :src="item.hotimg" />
      </div>
    </div>

    <div class="a-z">
      <p v-for="(item,index) in cityResults" @click="bindAZ(item.key)">{{item.key}}</p>
    </div>

    <div class="city-item-content" v-for="(item,index) in cityResults">
      <p class="city-item-A-Z border-box" :id="'bindAZ_'+item.key">{{item.key}}</p>
      <div class="city-name" v-for="(ite,ind) in item.value">
        <p class="city-item border-box hide" @click="citySelected(ite.city,ite.code)">{{ite.city}}</p>
      </div>
    </div>

  </div>

</template>

<script>

  import {getCityList} from "@/service/getData";
  import {wxGetPosition, getCityInfo} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        sregion: '', //省站点id
        latlng: {}, //经纬度信息
        cityInfo: {}, //城市信息

        cityResults: null,
        cityResultsAll: null,
        hotCitys: [],
        inputValue: '',

        TimeStamp: new Date().getTime(),  //获取当前时间
      }
    },
    computed: {

    },
    beforeDestroy(){

    },
    created() {
      let self = this;

      this.$loading.show('数据加载中');

      this.sregion = getStore("sregion") || '';

      this.cityInfo = getStore("cityInfo");

      this.initData();
      // this.getMyLocation();
    },
    methods: {
      //初始化数据
      async initData(){
        let res = await getCityList({
          TimeStamp: this.TimeStamp,
          name: this.inputValue, //搜索关键词
          sregion: this.sregion
        });
        if(res.errcode == "00000"){
          this.$loading.hide();

          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].key == "HOT") {
              this.hotCitys = res.data[i].value; //热门城市放入hotCitys中
              res.data.splice(i, 1)
            }
          }

          this.cityResults = res.data;
          this.cityResultsAll = res.data;

          console.log(this.cityResults);
        }
      },

      //重新定位
      getMyLocation(){
        let self = this;
        getCityInfo(function(res){
          self.latlng = res;
          self.cityInfo = getStore("cityInfo");
        });
      },

      //发送搜索信息inputVaule
      search(){
        this.$loading.show('数据加载中');
        this.initData();
      },

      //选择城市
      citySelected(city,citycode){
        let cityInfo = { citycode: citycode, city: city, address: "" };
        setStore("cityInfo",cityInfo);
        this.$router.go(-1);
      },

      //页面滑动到对应的字母处
      bindAZ(key){
        if(document.getElementById("bindAZ_"+key)){
          window.scrollTo(0,document.getElementById("bindAZ_"+key).offsetTop-55);
        }
      },

    },
    watch:  {
      inputValue(newVal,oldVal){
        if(newVal != oldVal){
          window.scrollTo(0,0);

          let cityResultsTemp = [];
          let citys = [];
          let citys1;
          for (var i = 0; i < this.cityResults.length; i++) {
            citys1 = this.cityResults[i]
            citys.push(citys1)
          }

          if (this.inputValue == null || this.inputValue.trim() == '' || this.inputValue == '') {
            this.cityResults = this.cityResultsAll;
            return;
          } else {
            for (var i = 0; i < citys.length; i++) {

              if (citys[i].key.indexOf(this.inputValue.toUpperCase()) >= 0) {
                cityResultsTemp.push(citys[i]);

              } else {
                var n = 0;
                var arr = {
                  key: "",
                  value: []
                };
                for (var j = 0; j < citys[i].value.length; j++) {
                  if (citys[i].value[j].city.indexOf(this.inputValue) >= 0 || citys[i].value[j].pinyin.indexOf(this.inputValue.toUpperCase()) >= 0) {

                    arr.key = citys[i].key;
                    arr.value[n] = citys[i].value[j];
                    n++;
                  }
                }
                if (arr.value.length > 0){
                  cityResultsTemp.push(arr);

                }
              }
            }
            this.cityResults = cityResultsTemp;
          }
        }
      }
    },
    components: {

    },

  }

</script>

<style scoped>

  .page{ padding-top:1.00rem; }
  .a-z{position:fixed;top:3.00rem;right:.05rem;width:.60rem;text-align:center;color:#faaf39;font-size:.22rem;z-index:9;}
  .a-z p{ height: .4rem; line-height: .4rem; }
  .search-box {position: fixed;top: 0;left:0;width: 100%;height: 1.00rem;line-height: 1.00rem;padding: 0 .20rem;background: #fff;font-size: .30rem;border-top:.01rem solid #f5f5f5;border-bottom:.01rem solid #f5f5f5;z-index:10;}
  .search-input {width:100%;height:.64rem;line-height:.64rem;margin-top:.18rem;padding-left:10%;border-radius:.30rem;background:#f3f3f3;box-shadow:0 .02rem .05rem #e5e4e4;box-sizing:border-box;font-size:.26rem;color:#666;}
  .icon-search{position:absolute;left:.50rem;top:50%;width:.24rem;height:.24rem;transform:translateY(-50%);}
  .search-input-placeholder {text-align: left;}
  .icon-address-box{width:100%;height:.80rem;line-height:.80rem;background:#ebebeb;font-size:.26rem;padding-left:.20rem;box-sizing:border-box;color:#666;}
  .location{width:100%;height:.80rem;line-height:.80rem;background:#fff;color:#3e3e3e;font-size:.28rem;box-sizing:border-box;padding:0 .20rem;}
  .location .fr{color:#faa92a;}
  .location .fr img{width:.23rem;height:.23rem; margin-right: .07rem;vertical-align: baseline; }
  .city-item-content {display: flex; width:100vw;overflow-x:hidden;flex-direction: column;justify-content: center;background-color: #FFFFFF;}
  .city-item {position:relative;height: .94rem;line-height: .94rem;margin: 0 .20rem;background: #fff;font-size: .28rem;color:#666;border-bottom:.01rem solid #f1eff2;}
  .city-item-content .city-name:last-child .city-item{border-bottom: none;}
  .city-item-A-Z{width:100%;height:.80rem;line-height:.80rem;font-size:.28rem;padding-left:.20rem;background-color:#ebebeb;color:#383838;text-align: left;}

  .hot-city-title{font-size: .26rem;color:#666;}
  .hot-city-box{padding: .24rem .20rem .48rem;background: #fff;}
  .hot-city-con{position:relative;display: inline-block;width: 22.48%;height:1.75rem;margin-right:3.33%;margin-top:.24rem;border-radius: .06rem; overflow: hidden;}
  .hot-city-con:nth-of-type(4n){margin-right:0;}
  .hot-city-img{position: absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .06rem;z-index: -1；}

</style>



// WEBPACK FOOTER //
// src/page/city/city.vue